import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

import { Typography } from 'antd'

import { icons, SmallSpinner } from 'portal/lib/primitives'
import * as routes from 'portal/routes'
import { datePickerChanged } from 'portal/store/global/actions'
import { loadRecordsCount } from 'portal/store/home/actions'

import {
  Tile,
  TileNumber,
  TileRow,
  Tiles,
  TitleBar,
  TitleBarIcon
} from './commonStyles'
import moment from 'moment'

export const Delivery = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { accountId, projectId } = useParams<{
    accountId: string
    projectId: string
  }>()

  const { Title } = Typography

  const userUuid = useSelector((state: any) => state.auth.userUuid)

  useEffect(() => {
    if (accountId && projectId) {
      dispatch(loadRecordsCount(accountId, projectId, 'delivery', 'total', {}))
      dispatch(loadRecordsCount(accountId, projectId, 'delivery', 'today', {}))
      dispatch(
        loadRecordsCount(accountId, projectId, 'delivery', 'last30Days', {})
      )
    }
  }, [dispatch, accountId, projectId])

  useEffect(() => {
    if (accountId && projectId && userUuid) {
      dispatch(
        loadRecordsCount(accountId, projectId, 'delivery', 'assignedToMe', {
          assignedTo: userUuid
        })
      )
    }
  }, [dispatch, accountId, projectId, userUuid])

  const deliveryCounts = useSelector((state: any) => state.home.delivery)

  const updateGlobalDateRangeAndGoToRecords = (period: string) => {
    let startDate: string | null = null
    const endDate = moment().endOf('day').toISOString()

    if (period === 'today') {
      startDate = moment().startOf('day').toISOString()
    } else if (period === 'last30Days') {
      startDate = moment().subtract(30, 'days').startOf('day').toISOString()
    } else {
      startDate = '2018-01-01T00:00:00.000Z'
    }

    const deliveryFiltersString =
      sessionStorage.getItem('delivery-filters') || '{}'
    const deliveryFilters = JSON.parse(deliveryFiltersString)

    // If assignedToMe update delivery-filters in session storage, else remove assignedTo filter
    if (period === 'assignedToMe' && userUuid) {
      deliveryFilters.assignedTo = [userUuid]
      sessionStorage.setItem(
        'delivery-filters',
        JSON.stringify(deliveryFilters)
      )
    } else if (deliveryFilters.assignedTo) {
      delete deliveryFilters.assignedTo
      sessionStorage.setItem(
        'delivery-filters',
        JSON.stringify(deliveryFilters)
      )
    }

    dispatch(
      datePickerChanged(
        {
          startDate,
          endDate
        },
        'global'
      )
    )

    if (accountId && projectId) {
      setTimeout(() => {
        navigate(
          generatePath(routes.DELIVERY_TABLE, {
            accountId: accountId,
            projectId: projectId
          })
        )
      }, 100)
    }
  }

  return (
    <>
      <TitleBar>
        <TitleBarIcon>
          <icons.Modules.Delivery />
        </TitleBarIcon>
        <Title level={4}>Delivery Records</Title>
      </TitleBar>
      <Tiles>
        <Tile onClick={() => updateGlobalDateRangeAndGoToRecords('total')}>
          <TileRow>
            <Title level={5}>Total</Title>
          </TileRow>
          <TileRow>
            {deliveryCounts.total.loading ? (
              <SmallSpinner />
            ) : (
              <TileNumber>
                {new Intl.NumberFormat().format(deliveryCounts?.total.count)}
              </TileNumber>
            )}
          </TileRow>
        </Tile>

        <Tile onClick={() => updateGlobalDateRangeAndGoToRecords('today')}>
          <TileRow>
            <Title level={5}>Today</Title>
          </TileRow>
          <TileRow>
            {deliveryCounts.today.loading ? (
              <SmallSpinner />
            ) : (
              <TileNumber>
                {new Intl.NumberFormat().format(deliveryCounts?.today.count)}
              </TileNumber>
            )}
          </TileRow>
        </Tile>

        <Tile onClick={() => updateGlobalDateRangeAndGoToRecords('last30Days')}>
          <TileRow>
            <Title level={5}>Last 30 days</Title>
          </TileRow>
          <TileRow>
            {deliveryCounts.last30Days.loading ? (
              <SmallSpinner />
            ) : (
              <TileNumber>
                {new Intl.NumberFormat().format(
                  deliveryCounts?.last30Days.count
                )}
              </TileNumber>
            )}
          </TileRow>
        </Tile>

        <Tile
          onClick={() => updateGlobalDateRangeAndGoToRecords('assignedToMe')}
        >
          <TileRow>
            <Title level={5}>Assigned to you</Title>
          </TileRow>
          <TileRow>
            {deliveryCounts.assignedToMe.loading ? (
              <SmallSpinner />
            ) : (
              <TileNumber>
                {new Intl.NumberFormat().format(
                  deliveryCounts?.assignedToMe.count
                )}
              </TileNumber>
            )}
          </TileRow>
        </Tile>
      </Tiles>
    </>
  )
}
